import { RootState } from 'lib/centralStore';
import { breakpoint } from 'utility/constant';
import { createSelector } from '@reduxjs/toolkit';

const _self = (state: RootState) => state.settings;

export const selectStreamingMode = createSelector(_self, (state) => state.streamingMode);
export const selectStreamingRoots = createSelector(_self, (state) => state.streamingRoots);
export const selectIsStreamingOpen = createSelector(_self, (state) => state.isStreamingOpen);
export const selectIsVisualizzazioneEstesa = createSelector(_self, (state) => state.isVisualizzazioneEstesa);
